import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("AutomationStore");
export const useAutomationStoreActions = useActions;
export const useAutomationStoreGetters = useGetters;
export const useAutomationStoreMutations = useMutations;
export const useAutomationStoreState = useState;